import {Map} from 'immutable';
import * as AuthActions from '../../actions/Auth';
import * as PhoneConfirm from '../../actions/PhoneConfirmation';

const initialState = Map({
    inProcess: false,
    error: null,
    requested: false,
    confirmed: false,
    reconfirmedPhone: null
});

export default function phoneConfirm(state = initialState, action = {}) {
    switch (action.type) {

        case AuthActions.BEGIN_JOIN:
            state = initialState;
            break;

        case PhoneConfirm.CREATE_PHONE_CONFIRMATION:
            state = state.set('confirmed', false);
            state = state.set('error', null);
            state = state.set('requested', false);
            state = state.set('inProcess', true);
            state = state.set('reconfirmedPhone', null);
            break;

        case PhoneConfirm.SUCCESS_CREATE_PHONE_CONFIRMATION:
            state = state.set('inProcess', false);
            if (action.data.Error) {
                state = state.set('error', action.data.Error);
            } else {
                state = state.set('error', null);
                state = state.set('requested', true);
                state = state.set('reconfirmedPhone', action.data.Phone);
            }
            break;

        case PhoneConfirm.FAILURE_CREATE_PHONE_CONFIRMATION:
            state = state.set('inProcess', false);
            break;

        case PhoneConfirm.CONFIRM_PHONE:
            state = state.set('inProcess', true);
            state = state.set('error', null);
            state = state.set('confirmed', false);
            break;

        case PhoneConfirm.SUCCESS_CONFIRM_PHONE:
            state = state.set('inProcess', false);
            if (action.data.Error) {
                state = state.set('error', action.data.Error);
            } else {
                state = state.set('error', null);
                state = state.set('confirmed', true);
            }
            break;

        case PhoneConfirm.FAILURE_CONFIRM_PHONE:
            state = state.set('inProcess', false);
            break;

        case PhoneConfirm.DENY_CONFIRMATION:
            state = state.set('requested', false);
            state = state.set('confirmed', false);
            break;
    }

    return state;
}


// WEBPACK FOOTER //
// ./js/shared/reducers/phoneConfirmReducer.js